<template>
  <Header />
  <div class="home">
    <div id="spinwheel-identity-connect" class="dim"></div>
  </div>
</template>

<script>
import api from '@/api/api.js'
import $store from '@/store.js'
import Header from '@/components/Header.vue'
import router from "@/router";

export default {
  name: 'Verify',
  components: {
    Header
  },
  data() {
  },
  mounted () {
    if (this.$route.params.guid2) {
      api.getToken({token: this.$route.params.guid2}).then((res) => {
        console.log('token');
        $store.tokenData = res.data.response;
        this.loadDIM();
      });
    } else {
      this.loadDIM();
    }
  },
  methods: {
    async sendEvent(event) {
      $store.metadata = event;
      try {
        await api.sendEvent(event)
      } catch (ex) {
        console.log(ex);
        $store.pageNotFound = 1;
        this.$router.push({ name: "error", });
      }
    },
    loadDIM() {
      const dob = $store.tokenData.dob.split('-');
      const config = {
        containerId: 'spinwheel-identity-connect',
        onSuccess: (metadata) => {
          console.log('onSuccess', metadata);
          this.sendEvent(metadata);
          this.$router.push({name: "success", });
        },
        onLoad: (metadata) => {
          console.log('onLoad', metadata);
          this.sendEvent(metadata);
        },
        onEvent: (metadata) => {
          console.log('onEvent', metadata);
          this.sendEvent(metadata);
          if (metadata.eventName == 'IDENTITY_NOT_CONNECTED') {
            this.$router.push({name: "debtconnect", }); //debt-connect
          }
          if (metadata.eventName == 'IDENTITY_CONNECTED') {
            this.$router.push({name: "success", });
            //this.$router.push({name: "debtconnect", }); //for test
          }
        },
        onError: (metadata) => {
          console.log('onError', metadata);
          this.sendEvent(metadata);
          this.$router.push({ name: "error", });
        },
        dropinConfig: {
          module: 'identity-connect',
          token: $store.tokenData.token,
          'primary-color1': $store.tokenData.companyColor,
          phoneNumber: $store.tokenData.phone,
          month: dob[1],
          day: dob[2],
          year: dob[0]
        },
      };
      const handler = window.Spinwheel && window.Spinwheel.create(config);
      handler.open();
    }
  }
}
</script>
<style scoped>
html {
  @apply text-gray-900;
}
p {
  @apply pt-1 text-sm font-medium leading-4;
}
h1 {
  @apply font-avenir font-bold;
}
.loader {
  border-top-color: #3498db;
}
.home {
  justify-content: center;
  display: flex;
}
.dim {
  width: 33rem;
  height: 40rem;
}
</style>